export const getFont = (fontFamily) => {
  const cssString = fontFamily;
  const fontRegex = /'([^']+)'/; // Regular expression to capture text between single quotes

  const match = cssString.match(fontRegex);
  if (match) {
    return match[1].toLowerCase(); // The captured text between single quotes
  }
};
